import axios from 'axios';
import Anti from '@pdd/risk-control-anti';
import { getHostUrl } from 'config/env';

const getServerTime = () => {
  const siteHost = getHostUrl('site');
  return axios.get(`${siteHost}/api/server/_stm`).then((response) => response.data.server_time);
};

interface Options {
  serverTime: number;
  localTime: number;
  promise: Promise<any> | null;
  anti: any;
}

const crawlerOptions = {
  // 浏览器反调试，true开启，false关闭，不传则开启，开发环境下设置false，线上设置true，开启反debug模式
  // _2827c887a48a351a: false,
  // 业务方服务器时间戳毫秒（ms）若不传sdk.js则自己取serverTime，qps大的业务强制传serverTime(搜索)
  serverTime: new Date().getTime(),
  // touch信息，不传则默认false，返回结果中不带该信息，
  touchEventData: true,
  // click信息
  clickEventData: true,
  // 聚焦失焦信息
  focusblurEventData: true,
  // input信息
  changeEventData: true,
  // location信息 建议所有请求带上
  locationInfo: true,
  // referrer信息 建议所有请求带上
  referrer: true,
  // 浏览器视窗大小信息 建议所有请求带
  browserSize: true,
  // 浏览器ua 建议所有请求带上
  browserInfo: true,
  // 防重放信息 建议所有请求带上
  token: true,
  // fingerprint信息 建议所有请求带上
  fingerprint: true,
};

function antiFactory(getServerTime: any) {
  const _defaults: any = antiFactory.defaults;
  const { serverTime, localTime, promise, anti }: Options = _defaults;
  // 都具备，那不再请求
  if (serverTime && localTime && anti) {
    // 重新计算最新时间
    anti.updateServerTime(+new Date().getTime() + serverTime - localTime);
    return (_defaults.promise = Promise.resolve(anti)) as Promise<any>;
  }
  if (promise) {
    // 当请求还没有回来时
    return promise;
  }
  if (getServerTime) {
    // Content-type", "application/json; charset=utf-8"
    // withCredentials = true;
    return (_defaults.promise = getServerTime().then((serverTime: any) => {
      // 初始化反爬实例
      crawlerOptions.serverTime = serverTime;
      const anti = new Anti(crawlerOptions);
      Object.assign(_defaults, {
        serverTime,
        localTime: +new Date().getTime(),
        anti: anti,
        // 不再缓存到promise
        promise: null,
      });
      return anti;
    })) as Promise<any>;
  }
  // error handling
  return Promise.reject(new Error('Invalid Option: risk anti has to input a serverTime.'));
}

antiFactory.defaults = {
  serverTime: crawlerOptions.serverTime,
  localTime: 0,
  promise: null,
  anti: null,
};

// 获取反爬参数，未获取到返回空字符串
const getRisk = () => {
  return antiFactory(getServerTime)
    .then((anti) => {
      return anti
        .messagePackSync()
        .then((crawlerInfo: any) => {
          return crawlerInfo;
        })
        .catch(() => {
          return '';
        });
    })
    .catch(() => {
      return '';
    });
};

export { antiFactory, getRisk };
